export default __webpack_public_path__ + "static/media/image27.9cccc852.png";